import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import icons, {faSpinner} from '@fortawesome/fontawesome-free-solid';
import './submit.scss';

export class Submit extends Component {
    render() {
        const {process, icon, text, disabled, className, onClick} = this.props;
        const type = onClick ? '' : 'submit';
        const click = onClick || null;

        return (
            <button 
                className={`formSubmitButton ${className || ''}`} 
                type={type} disabled={process || disabled || false}
                onClick={click}
            >
                {(icon && !process) && <FontAwesomeIcon icon={icons[icon]} />}
                {process && <FontAwesomeIcon icon={faSpinner} spin />}
                {!process && ` ${text}`}
            </button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Form/Submit.jsx